(function () {
  // خريطة ألوان شاملة (ضيف/عدّل براحتك)
  const MAP = {
    black:"#000000", white:"#FFFFFF", offwhite:"#F5F5F5", ivory:"#FFFFF0",
    grey:"#9E9E9E", gray:"#9E9E9E", lightgrey:"#D5D5D5", darkgrey:"#5A5A5A",
    silver:"#C0C0C0", charcoal:"#333333",
    beige:"#D9C9B6", sand:"#E2D2BE", taupe:"#BFAEA0", cream:"#FFF4E0",
    brown:"#7B5E3B", chocolate:"#5A3A1B", tan:"#C69C6D",
    nude:"#EDD6C4",
    red:"#E53935", burgundy:"#800020", maroon:"#7F1D1D",
    pink:"#FF7FAB", rose:"#F06292", blush:"#F8C8D8", coral:"#FF6F61", salmon:"#FA8072",
    orange:"#FB8C00", peach:"#FFCBA4",
    yellow:"#FDD835", gold:"#D4AF37", mustard:"#D6A300",
    green:"#43A047", olive:"#808000", mint:"#AAF0D1", khaki:"#BDB76B", lime:"#8BC34A",
    teal:"#008080", turquoise:"#40E0D0",
    blue:"#1E88E5", navy:"#001F3F", sky:"#87CEEB", cobalt:"#0047AB",
    purple:"#8E24AA", violet:"#7F00FF", lavender:"#B57EDC",
    multicolor:"#CCCCCC", multi:"#CCCCCC", rainbow:"#CCCCCC",
    // عربي شائع
    "أسود":"#000000","أبيض":"#FFFFFF","رمادي":"#9E9E9E","بيج":"#D9C9B6","سكري":"#FFF4E0",
    "بني":"#7B5E3B","أحمر":"#E53935","نبيتي":"#800020","وردي":"#FF7FAB","روز":"#F06292",
    "برتقالي":"#FB8C00","أصفر":"#FDD835","ذهبي":"#D4AF37","أخضر":"#43A047","زيتي":"#808000",
    "نعناعي":"#AAF0D1","تركواز":"#40E0D0","أزرق":"#1E88E5","كحلي":"#001F3F","بنفسجي":"#8E24AA"
  };

  // دالة تجيب النص وتحوّله لمفتاح
  function norm(txt) {
    return String(txt || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z\u0600-\u06FF]+/g, ""); // يسمح بالإنجليزي والعربي
  }

  // حط لون الخلفية للدائرة
  function paint(node, hex) {
    if (!node || !hex) return;
    node.style.background = hex;
    node.style.backgroundImage = "none";
  }

  // حاول تلوين عنصر سواتش واحد
  function handleItem(item) {
    if (!item) return;

    // أنماط محتملة لعناصر السواتش حسب الثيم
    const swatch =
      item.querySelector(".facets__color-swatch, .facets__swatch, .facet-color, .swatch, .color-swatch, .swatch__indicator");

    // لو السواتش موجود بالفعل وفيه background فابركه
    if (swatch && swatch.style && swatch.style.backgroundColor) return;

    // هات اسم اللون من الليبل
    let labelNode =
      item.querySelector(".facet-checkbox__text, .facets__label, label, .caption, .text-body");
    const text = norm(labelNode ? labelNode.textContent : item.textContent);

    // لو فيه data-color/aria-label على العنصر استخدمه
    const data = norm(
      (item.getAttribute && (item.getAttribute("data-color") || item.getAttribute("aria-label"))) ||
      (swatch && (swatch.getAttribute("data-color") || swatch.getAttribute("aria-label")))
    );

    const key = data || text;
    const hex = MAP[key];

    if (swatch && hex) paint(swatch, hex);
  }

  // نفّذ على كل عناصر الفلتر
  function run(root = document) {
    const items = root.querySelectorAll(
      // عناصر خيار اللون في فلاتر Shopify
      ".facets__item, .facet-checkbox, li[data-facet], .filter-item"
    );
    items.forEach(handleItem);
  }

  // شغّل عند التحميل
  document.addEventListener("DOMContentLoaded", run);

  // لما يتغيّر سيكشن (Shopify sections events)
  document.addEventListener("shopify:section:load", (e) => run(e.target));
  document.addEventListener("shopify:section:select", (e) => run(e.target));

  // رصد تغييرات DOM لو الفلاتر بتتبدل Ajax
  const obs = new MutationObserver((m) => run());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
